import { Controller } from "@hotwired/stimulus";

// 이미 같은 폰트를 구매한 사용자가 재구매 동의 체크 없이 결제하지 못하도록 막는다.
// 결제 버튼의 click 액션(tosspayments/identity-verification)보다 먼저 실행되어야 하므로
// 상위 요소에서 capture 단계로 가로챈다.
export default class extends Controller {
  static targets = [
    "agreement",
    "paymentButton"
  ];

  guardPayment(event) {
    // 구매 이력 안내가 없는 주문이면 체크할 것도 없다.
    if (!this.hasAgreementTarget || this.agreementTarget.checked) return;
    if (!this.hasPaymentButtonTarget || !this.paymentButtonTarget.contains(event.target)) return;

    event.preventDefault();
    event.stopPropagation();

    // 체크되지 않은 required 체크박스이므로 브라우저 기본 검증 메시지가 노출된다.
    // (필요하면 브라우저가 알아서 해당 위치로 스크롤해준다)
    this.agreementTarget.reportValidity();
  }
}
